import type { SalesMetricType as SalesMetricApiType } from 'src/api/generated/touring/types';
import type { SalesMetricType } from '../../types';

export const mapSalesMetricType = (
  api: SalesMetricApiType
): SalesMetricType => ({
  date: api.date,
  salesTotal: api.salesTotal,
  salesIncrease: api.salesIncrease,
});
